import AccessRestrictedBanner from "features/AccessManagement/AccessRestrictedBanner"
import UnverifiedEmailBanner from "features/Settings/UnverifiedEmailBanner"
import PaymentFailedBanner from "features/SuraasaPlus/PaymentFailedBanner/banner"

const GlobalBanners = () => {
  return (
    <div id="globalTopBars">
      <UnverifiedEmailBanner />
      <AccessRestrictedBanner />
      <PaymentFailedBanner />
    </div>
  )
}

export default GlobalBanners
